import PropTypes from 'prop-types';
import styled from 'styled-components';
import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { withRouter } from 'utils/withRouter';
import { getCachedServiceCenter, cacheSelectedServiceCenter } from 'utils/service-center';
import { injectIntl } from 'react-intl';

const { Option, OptGroup } = Select;

const StyledSelect = styled(Select)`
 ${p => p.extraStyles}
 font-size: 16px;
 font-weight: 400;
`;

const Title = styled.p`
  font-weight: bold;
  color: black;
`;

const ServiceCenterToggle = ({
  fetchActionRequiredCount,
  clearNavigationalInfo,
  clearReferenceData,
  history,
  needsRedirect = true,
  serviceCenters,
  setActiveServiceCenter,
  currentServiceCenter,
  extraStyles = '',
  adminFor,
  intl,
  onlyAdmin = false,
  disabled = false,
  fetchUser,
  getIsDecimal,
}) => {
  const [selectedServiceCenter, setSelectedServiceCenter] = useState(() => {
    const activeServiceCenter = getCachedServiceCenter();
    if (currentServiceCenter !== activeServiceCenter) {
      setActiveServiceCenter(activeServiceCenter);
    }
    return activeServiceCenter;
  });

  useEffect(() => {
    setSelectedServiceCenter(currentServiceCenter);
  }, [currentServiceCenter]);

  const handleChange = (value) => {
    const result = cacheSelectedServiceCenter(value);
    fetchUser();
    setActiveServiceCenter(result);
    fetchActionRequiredCount();
    clearNavigationalInfo();
    clearReferenceData();
    getIsDecimal(result);
    if (needsRedirect) {
      history.push('/home', { context: '' });
    }
  };

  const getGroupTitle = key =>
    <Title>{intl.formatMessage({ id: `userManagement.${key}` })}{':'}</Title>;

  // getPopupContainer garantees that the select is rendered into the popover,
  // so scrolling/selecting/.. does not close the popover
  // https://codepen.io/anon/pen/xVBOVQ?editors=001
  return (
    <StyledSelect
      data-test-id='service-center-toggle'
      getPopupContainer={triggerNode => triggerNode.parentNode}
      value={selectedServiceCenter}
      onChange={handleChange}
      disabled={disabled}
      allowClear={false}
      showSearch={true}
      extraStyles={extraStyles}
      filterOption={(input, option) => {
        if (option.children) {
          return option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0;
        }
        return false;
      }}
    >
      <OptGroup label={getGroupTitle('ADMIN_FOR')}>
        {adminFor?.map(s =>
          <Option value={s.id} key={`af_${s.id}`}>
            {s.name}
          </Option>,
        )}
      </OptGroup>
      {
        !onlyAdmin &&
        <OptGroup label={getGroupTitle('ACCESS_TO')}>
          {serviceCenters?.map(s =>
            <Option value={s.id} key={`at_${s.id}`}>
              {s.name}
            </Option>,
          )}
        </OptGroup>
      }
    </StyledSelect>
  );
};

ServiceCenterToggle.propTypes = {
  serviceCenters: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  fetchActionRequiredCount: PropTypes.func.isRequired,
  clearNavigationalInfo: PropTypes.func.isRequired,
  clearReferenceData: PropTypes.func.isRequired,
  setActiveServiceCenter: PropTypes.func.isRequired,
  getIsDecimal: PropTypes.func,
  currentServiceCenter: PropTypes.object,
  needsRedirect: PropTypes.bool,
  extraStyles: PropTypes.string,
  adminFor: PropTypes.array,
  intl: PropTypes.object,
  onlyAdmin: PropTypes.bool,
  disabled: PropTypes.bool,
  fetchUser: PropTypes.func.isRequired,
};

export default injectIntl(withRouter(ServiceCenterToggle));
